import { faCheck } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Link, graphql, useStaticQuery } from "gatsby"
import * as React from "react"
import styled, { ThemeProvider } from "styled-components"
import Helmet from "react-helmet"

import { GlobalStyle } from "../components/layout"
import Logo from "../assets/images/logo.png"
import googleReviews from "../assets/images/google-reviews.png"
import FormGroup from "../components/FormGroup"
import Label from "../components/Label"
import Input from "../components/Input"
import theme from "../theme"
import SEO from "../components/seo"

const StyledLayout = styled.section`
  display: grid;
  grid-template-columns: 1fr;
  .sidebar {
    padding: 2.5rem;
    background-color: ${({ theme }) => theme.colors.obsidian};
    color: #fff;
    .logo {
      margin-bottom: 2rem;
      img {
        display: block;
        max-width: 200px;
        margin: 0 auto;
      }
    }
    .list-container {
      h5 {
        margin-bottom: 2rem;
        color: #fff;
      }
      ul {
        list-style-type: none;
        padding: 0;
        margin: 0;
        li {
          margin-bottom: 1rem;
          display: flex;
          align-items: center;
          &:last-child {
            margin-bottom: 0;
          }
          svg {
            margin-right: 1rem;
            color: ${({ theme }) => theme.colors.green};
          }
        }
      }
    }
    .reviews {
      max-width: 125px;
      margin: 0 auto;
      display: none;
    }
  }
  .form {
    padding: 4rem 0;
    display: flex;
    align-items: center;
  }
  @media only screen and (min-width: 1000px) {
    grid-template-columns: 1fr 2fr;
    grid-gap: 0;
    min-height: 100vh;
    .list-container {
      margin-bottom: 4rem;
      h5 {
        margin-bottom: 2rem;
      }
      ul {
        li {
          margin-bottom: 1rem;
        }
      }
    }
    .sidebar {
      padding: 4rem 2.5rem;
      .reviews {
        display: block;
      }
    }
    .logo {
      margin-bottom: 4rem;
    }
  }
`

const StyledForm = styled.form`
  padding: 0 2rem;
  margin: 0 auto;
  width: 100%;
  h3 {
    margin-bottom: 20px;
  }
  .btn {
    width: 100%;
  }
  @media only screen and (min-width: 1000px) {
    width: 60%;
  }
`

export default () => {
  const data = useStaticQuery(graphql`
    query GetStartedQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)
  return (
    <ThemeProvider theme={theme}>
      <SEO title="Get Started" />
      <GlobalStyle />
      <Helmet>
        <link
          href="https://fonts.googleapis.com/css?family=Fira+Sans:400,600,700,800,900|Heebo:400,700&display=swap"
          rel="stylesheet"
        />
      </Helmet>
      <StyledLayout>
        <div className="sidebar">
          <div className="logo">
            <Link to="/">
              <img src={Logo} alt={data.site.siteMetadata.siteName} />
            </Link>
          </div>
          <div className="list-container">
            <h5>Dealer 9000 benefits</h5>
            <ul>
              <li>
                <FontAwesomeIcon icon={faCheck} />
                Increases leads by as much as 15%
              </li>
              <li>
                <FontAwesomeIcon icon={faCheck} />
                Sell 24/7 with our Online Deposits software.
              </li>
              <li>
                <FontAwesomeIcon icon={faCheck} />1 month free trial and then
                just £29/month
              </li>
            </ul>
          </div>
          <img className="reviews" src={googleReviews} alt="Google Reviews" />
        </div>
        <div className="form">
          <StyledForm
            name="get-started"
            method="post"
            data-netlify="true"
            data-netlify-honeypot="bot-field"
            action="/get-started-thanks"
          >
            <h1 className="text-center">Try Dealer 9000</h1>
            <input type="hidden" name="form-name" value="get-started" />
            <input type="hidden" name="bot-field" />
            <FormGroup>
              <Label>Your name</Label>
              <Input type="text" name="name" id="name" required={true} />
            </FormGroup>
            <FormGroup>
              <Label>Dealership name</Label>
              <Input
                type="text"
                name="dealership"
                id="dealership"
                required={true}
              />
            </FormGroup>
            <FormGroup>
              <Label>Email</Label>
              <Input type="email" name="email" id="email" required={true} />
            </FormGroup>
            <FormGroup>
              <Label>Phone</Label>
              <Input type="tel" name="phone" id="phone" required={true} />
            </FormGroup>
            <button className="btn" type="submit">
              Start Free Trial
            </button>
          </StyledForm>
        </div>
      </StyledLayout>
    </ThemeProvider>
  )
}
